import ClockIconSVG from './clockIcon'
import EditorsPickIconSVG from './editorsPickIcon'
import ExclusiveIconSVG from './exclusiveIcon'
import ViewIconSVG from './viewIcon'

export function FacebookIcon() {
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="fackbook-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="facebook" fill="#F2F4F7">
          <path
            d="M15.8861593,0 C24.6598428,0 31.7723186,7.11247578 31.7723186,15.8861593 C31.7723186,24.6598428 24.6598428,31.7723186 15.8861593,31.7723186 C7.11247578,31.7723186 0,24.6598428 0,15.8861593 C0,7.11247578 7.11247578,0 15.8861593,0 Z M16.823269,8.528 C13.8677161,8.528 13.1961504,10.5692278 13.1961504,11.872781 L13.1961504,11.872781 L13.1961504,13.6956571 L11.4863009,13.6956571 L11.4863009,16.5125908 L13.1961504,16.5125908 L13.1961504,24.528 L16.7912671,24.528 L16.7912671,16.5125908 L19.1641485,16.5125908 L19.4782411,13.6982799 L16.7915042,13.6982799 L16.7915042,12.0404244 C16.7915042,11.4185919 17.2371602,11.272587 17.5540975,11.272587 L17.5540975,11.272587 L19.4863009,11.272587 L19.4863009,8.5382728 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function InstagramIcon() {
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="instagram-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="instagram" fill="#F2F4F7" fillRule="nonzero">
          <path
            d="M15.9569778,3.2471803e-13 C24.7694222,3.2471803e-13 31.9139556,7.14453333 31.9139556,15.9569778 C31.9139556,24.7694222 24.7694222,31.9139556 15.9569778,31.9139556 C7.14453333,31.9139556 -5.32907052e-15,24.7694222 -5.32907052e-15,15.9569778 C-5.32907052e-15,7.14453333 7.14453333,3.2471803e-13 15.9569778,3.2471803e-13 Z M20.7128889,6.40142222 L11.2010667,6.40142222 C8.60301261,6.40142222 6.47619304,8.45802412 6.36312759,11.0287083 L6.3584,11.2440889 L6.3584,20.7559111 C6.3584,23.3543111 8.4150019,25.4808034 10.985686,25.5938509 L11.2010667,25.5985778 L20.7128889,25.5985778 C23.3112889,25.5985778 25.4377812,23.5423125 25.5508287,20.971319 L25.5555556,20.7559111 L25.5555556,11.2440889 C25.5555556,8.57386667 23.3834667,6.40142222 20.7128889,6.40142222 Z M11.2010667,8.49066667 L20.7128889,8.49066667 C22.175223,8.49066667 23.3747816,9.63606475 23.4616319,11.0766106 L23.4666667,11.2440889 L23.4666667,20.7559111 C23.4666667,22.2182453 22.3209389,23.4178039 20.8803686,23.5046541 L20.7128889,23.5096889 L11.2010667,23.5096889 C9.7390749,23.5096889 8.53952897,22.3639611 8.4526792,20.9233908 L8.44764444,20.7559111 L8.44764444,11.2440889 C8.44764444,9.78209712 9.59304252,8.5825512 11.0335884,8.49570142 L11.2010667,8.49066667 L20.7128889,8.49066667 Z M15.9569778,11.056 C13.2309333,11.056 11.0129778,13.2739556 11.0129778,16 C11.0129778,18.7264 13.2309333,20.9443556 15.9569778,20.9443556 C18.6830222,20.9443556 20.9013333,18.7260444 20.9013333,16 C20.9013333,13.2739556 18.6833778,11.056 15.9569778,11.056 Z M15.9569778,13.1452444 C17.5310222,13.1452444 18.8117333,14.4263111 18.8117333,15.9996444 C18.8117333,17.5740444 17.5313778,18.8551111 15.9569778,18.8551111 C14.3832889,18.8551111 13.1018667,17.5740444 13.1018667,15.9996444 C13.1018667,14.4259556 14.3832889,13.1452444 15.9569778,13.1452444 Z M21.0602667,9.73866667 C20.4149333,9.73866667 19.8901333,10.2634667 19.8901333,10.9084444 C19.8901333,11.5534222 20.4149333,12.0782222 21.0602667,12.0782222 C21.7052444,12.0782222 22.2300444,11.5534222 22.2300444,10.9084444 C22.2300444,10.2634667 21.7052444,9.73866667 21.0602667,9.73866667 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function LinkedinIcon() {
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="linkedin-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Google" fill="#F2F4F7" fillRule="nonzero">
          <path
            d="M15.8861593,-5.14077669e-12 C24.6598428,-5.14077669e-12 31.7723186,7.11247578 31.7723186,15.8861593 C31.7723186,24.6598428 24.6598428,31.7723186 15.8861593,31.7723186 C7.11247578,31.7723186 1.58060232e-11,24.6598428 1.58060232e-11,15.8861593 C1.58060232e-11,7.11247578 7.11247578,-5.14077669e-12 15.8861593,-5.14077669e-12 Z M20.026,13.0493333 C18.4126667,13.0493333 17.33,13.9346667 16.888,14.774 L16.888,14.774 L16.8413333,14.774 L16.8413333,13.3173333 L13.6593333,13.3173333 L13.6593333,23.9993333 L16.9726667,23.9993333 L16.9726667,18.71 L16.9737314,18.561021 C16.9933869,17.2228605 17.2982619,15.9706667 18.9613333,15.9706667 C20.6606667,15.9706667 20.686,17.56 20.686,18.7993333 L20.686,18.7993333 L20.686,24 L24,23.9993333 L24,18.1313333 L23.9989204,17.927428 C23.9690193,15.1566187 23.3020952,13.0493333 20.026,13.0493333 Z M11.5813333,13.318 L8.264,13.318 L8.264,24 L11.5813333,24 L11.5813333,13.318 Z M9.92133333,8 C8.86066667,8 8,8.86066667 8,9.92133333 C8,10.982 8.86066667,11.8606667 9.92133333,11.8606667 C10.982,11.8606667 11.8426667,10.982 11.8426667,9.92133333 C11.842,8.86066667 10.9813333,8 9.92133333,8 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function TelegramIcon() {
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="telegram-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Google-Copy-2" fill="#F2F4F7">
          <path
            d="M15.8861593,0 C24.6598428,0 31.7723186,7.11247578 31.7723186,15.8861593 C31.7723186,24.6598428 24.6598428,31.7723186 15.8861593,31.7723186 C7.11247578,31.7723186 0,24.6598428 0,15.8861593 C0,7.11247578 7.11247578,0 15.8861593,0 Z M21.8035369,9.07980371 L5.83565346,15.1930222 C4.74587729,15.61602 4.76237769,16.2235169 5.65039901,16.4987655 L9.73274705,17.768509 L19.2152248,11.8352895 C19.6614855,11.539791 20.0672452,11.7032902 19.7334872,11.9987887 L12.063053,18.8860032 L11.7652959,23.0739816 C12.1913061,23.0739816 12.3758105,22.8909826 12.5970658,22.6712337 L14.5943638,20.7624935 L18.7329632,23.7932279 C19.4919814,24.2162258 20.0267443,23.9934769 20.2314992,23.0949815 L22.9480644,10.3660471 L22.9488144,10.3652971 C23.1895702,9.24330287 22.5430547,8.80455513 21.8035369,9.07980371 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function TwitterIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_202_150)">
        <path fillRule="evenodd" clipRule="evenodd" d="M16 0C7.16345 0 0 7.16345 0 16C0 24.8366 7.16345 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16345 24.8366 0 16 0ZM13.8597 17.1118L6.44681 7.2H12.1601L17.0198 13.698L23.0346 7.2H24.7134L17.77 14.7011L25.6 25.1704H19.8867L14.6098 18.115L8.07888 25.1704H6.4L13.8597 17.1118ZM11.5404 8.43664H8.91576L20.506 23.9336H23.1307L11.5404 8.43664Z" fill="#F2F4F7" />
      </g>
      <defs>
        <clipPath id="clip0_202_150">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function YoutubeIcon() {
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="youtube-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M15.8861593,-3.93285404e-12 C24.6598428,-3.93285404e-12 31.7723186,7.11247578 31.7723186,15.8861593 C31.7723186,24.6598428 24.6598428,31.7723186 15.8861593,31.7723186 C7.11247578,31.7723186 2.44781972e-12,24.6598428 2.44781972e-12,15.8861593 C2.44781972e-12,7.11247578 7.11247578,-3.93285404e-12 15.8861593,-3.93285404e-12 Z M16.8277862,9.60025513 L16.0028153,9.60014684 C13.8036103,9.59890281 11.5942314,9.60014684 9.41174073,9.83846686 C8.49063629,9.93923304 7.72559273,10.6147397 7.51012333,11.5303435 C7.23752648,12.6893817 7.20451053,13.9427817 7.20053905,15.1498745 L7.2,15.6000889 C7.2,16.9425717 7.2,18.3657385 7.50667146,19.6694788 C7.72177751,20.5849049 8.48700274,21.2604116 9.40865222,21.3613555 C11.3181726,21.570041 13.2482793,21.5970791 15.1742652,21.5997446 L15.9993635,21.5998532 C18.1989318,21.6010972 20.407584,21.5998532 22.5897113,21.3613555 C23.5108158,21.2605893 24.276586,20.5850826 24.4920554,19.6694788 C24.7648138,18.5104406 24.7959821,17.2571811 24.799541,16.0502443 L24.7999993,15.6000889 C24.7999993,14.2576061 24.8025421,12.8342615 24.4958707,11.5303435 C24.2804013,10.6147397 23.5148127,9.93923304 22.5931632,9.83846686 C20.6834839,9.62993684 18.7534964,9.60291813 16.8277862,9.60025513 Z M13.7287592,12.5787028 C15.5940412,13.5307389 17.446969,14.4763771 19.32406,15.4342779 L13.7287592,18.2722588 L13.7287592,18.2722588 L13.7287592,12.5787028 L13.7287592,12.5787028 Z"
          id="Combined-Shape"
          fill="#F2F4F7"
        ></path>
      </g>
    </svg>
  )
}

export function ThreadsIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_118_146)">
        <path fillRule="evenodd" clipRule="evenodd" d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM20.6738 14.7685C20.7654 14.8078 20.8558 14.8488 20.9448 14.8913C22.2029 15.4937 23.123 16.4056 23.6056 17.5285C24.2782 19.0943 24.3397 21.6449 22.2988 23.6797C20.7389 25.2351 18.8454 25.937 16.159 25.9556H16.1469C13.1253 25.9347 10.8018 24.9199 9.24081 22.9397C7.85177 21.1774 7.13526 18.7253 7.11119 15.6517L7.11111 15.6444L7.11119 15.6372C7.13526 12.5635 7.85177 10.1115 9.24081 8.34926C10.8018 6.36893 13.1253 5.35422 16.1469 5.33333H16.159C19.1868 5.35429 21.5366 6.36516 23.1433 8.33795C23.9361 9.31124 24.5187 10.4848 24.8889 11.8468L23.1511 12.3095C22.8456 11.203 22.3823 10.2541 21.7678 9.49945C20.5145 7.96067 18.6256 7.17121 16.153 7.15287C13.6981 7.17107 11.8416 7.95675 10.6345 9.48814C9.50419 10.9221 8.92002 12.9934 8.89823 15.6444C8.92002 18.2955 9.50419 20.3667 10.6345 21.8007C11.8416 23.3321 13.6982 24.1178 16.153 24.136C18.366 24.1197 19.8303 23.5943 21.0485 22.3797C22.4389 20.9933 22.413 19.2928 21.9683 18.2579C21.7068 17.6491 21.2332 17.1427 20.5943 16.7578C20.4386 17.9154 20.0862 18.834 19.5289 19.5429C18.7951 20.4764 17.7433 20.9869 16.4025 21.0602C15.3873 21.1156 14.4104 20.8712 13.652 20.3716C12.7549 19.7805 12.2299 18.8757 12.1737 17.824C12.063 15.7506 13.7111 14.2584 16.2748 14.111C17.1848 14.059 18.0361 14.1 18.8233 14.2335C18.7188 13.5956 18.5077 13.0902 18.1922 12.7245C17.7586 12.2221 17.0886 11.9645 16.2008 11.9588L16.1761 11.9587C15.4633 11.9587 14.4954 12.1578 13.8786 13.0917L12.3957 12.0764C13.2213 10.8262 14.5626 10.1392 16.1754 10.1392L16.212 10.1393C18.9084 10.1565 20.5143 11.8356 20.6738 14.7685ZM13.9581 17.7251C14.0157 18.8032 15.183 19.3065 16.3066 19.2433C17.4066 19.1831 18.6553 18.7523 18.8682 16.0991C18.2975 15.9746 17.6697 15.9095 16.9986 15.9095C16.7947 15.9095 16.5871 15.9155 16.3755 15.9277C14.5281 16.0339 13.9155 16.9258 13.9581 17.7251Z" fill="#F2F4F7" />
      </g>
      <defs>
        <clipPath id="clip0_118_146">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function CupIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="cup-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M19,5 L17,5 L17,3 L7,3 L7,5 L5,5 C3.9,5 3,5.9 3,7 L3,8 C3,10.55 4.92,12.63 7.39,12.94 C8.02,14.44 9.37,15.57 11,15.9 L11,19 L7,19 L7,21 L17,21 L17,19 L13,19 L13,15.9 C14.63,15.57 15.98,14.44 16.61,12.94 C19.08,12.63 21,10.55 21,8 L21,7 C21,5.9 20.1,5 19,5 Z M5,8 L5,7 L7,7 L7,10.82 C5.84,10.4 5,9.3 5,8 Z M19,8 C19,9.3 18.16,10.4 17,10.82 L17,7 L19,7 L19,8 Z"
          id="Shape"
          fill="#0E3778"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

export function FantasyTipsIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="fantasy-tips-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M10.1111111,21 L13.6666667,21 C13.6666667,22 12.8666667,22.8181818 11.8888889,22.8181818 C10.9111111,22.8181818 10.1111111,22 10.1111111,21 Z M8.11111111,19.8181818 L15.2222222,19.8181818 L15.2222222,18 L8.11111111,18 L8.11111111,19.8181818 Z M18.4444444,11.8181818 C18.4444444,15.2909091 16.08,17.1454545 15.0933333,17.7272727 L8.46222222,17.7272727 C7.47555556,17.1454545 5.11111111,15.2909091 5.11111111,11.8181818 C5.11111111,8.05454545 8.09777778,5 11.7777778,5 C15.4577778,5 18.4444444,8.05454545 18.4444444,11.8181818 Z M19.7733333,9.7 L18.5555556,10.2727273 L19.7733333,10.8454545 L20.3333333,12.0909091 L20.8933333,10.8454545 L22.1111111,10.2727273 L20.8933333,9.7 L20.3333333,8.45454545 L19.7733333,9.7 Z M4.66666667,7.45454545 L5.50222222,5.58181818 L7.33333333,4.72727273 L5.50222222,3.87272727 L4.66666667,2 L3.83111111,3.87272727 L2,4.72727273 L3.83111111,5.58181818 L4.66666667,7.45454545 Z"
          id="Shape"
          fill="#0E3778"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

// export function FeaturedIcon() {
//   return (
//     <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
//       <g id="featured-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <polygon
//           fill="#0E3778"
//           fillRule="nonzero"
//           points="16 6 18.29 8.29 13.41 13.17 9.41 9.17 2 16.59 3.41 18 9.41 12 13.41 16 19.71 9.71 22 12 22 6"
//         ></polygon>
//       </g>
//     </svg>
//   )
// }

export function NewsIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="news-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M16,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,8 L16,3 Z M7,7 L12,7 L12,9 L7,9 L7,7 Z M17,17 L7,17 L7,15 L17,15 L17,17 Z M17,13 L7,13 L7,11 L17,11 L17,13 Z M15,9 L15,5 L19,9 L15,9 Z"
          id="Shape"
          fill="#0E3778"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

// export function StarIcon() {
//   return (
//     <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
//       <g id="star-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <g id="Group-22">
//           <rect id="Rectangle" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="24" height="24"></rect>
//           <path
//             d="M16.2743957,17.8832009 L14.8859506,12.9377022 L18.9161175,9.7528172 L13.7836156,9.5450638 L12,4.72796372 L10.2163844,9.5450638 L5.08388251,9.7528172 L9.11404941,12.9377022 L7.72560432,17.8832009 L12,15.034468 L16.2743957,17.8832009 Z"
//             id="Star"
//             stroke="#323842"
//             strokeWidth="1.2"
//           ></path>
//         </g>
//       </g>
//     </svg>
//   )
// }

// export function StarFillIcon() {
//   return (
//     <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
//       <g id="Colors-&amp;-Typography" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <g id="star-fill-icon" fill="#A6C8FF">
//           <polygon
//             id="Star"
//             points="11.5595086 17.5 6.26944138 20.2811529 7.27975432 14.3905765 3 10.2188471 8.91447501 9.35942353 11.5595086 4 14.2045423 9.35942353 20.1190173 10.2188471 15.839263 14.3905765 16.8495759 20.2811529"
//           ></polygon>
//         </g>
//       </g>
//     </svg>
//   )
// }

// export function TeamsIcon() {
//   return (
//     <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
//       <g id="star-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <g id="Group-22">
//           <rect id="Rectangle" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="24" height="24"></rect>
//           <path
//             d="M16.2743957,17.8832009 L14.8859506,12.9377022 L18.9161175,9.7528172 L13.7836156,9.5450638 L12,4.72796372 L10.2163844,9.5450638 L5.08388251,9.7528172 L9.11404941,12.9377022 L7.72560432,17.8832009 L12,15.034468 L16.2743957,17.8832009 Z"
//             id="Star"
//             stroke="#323842"
//             strokeWidth="1.2"
//           ></path>
//         </g>
//       </g>
//     </svg>
//   )
// }

export function DownloadIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_621_560)">
        <path d="M15.36 16.8C15.36 16.8 19.3497 16.8 19.727 16.8C21.8222 16.8 23.52 15.1023 23.52 13.0076C23.52 10.9128 21.8222 9.21459 19.727 9.21459C19.7174 9.21459 19.7088 9.21603 19.6992 9.21603C19.7285 8.97891 19.7486 8.73891 19.7486 8.49411C19.7486 5.27331 17.1379 2.66211 13.9166 2.66211C11.4067 2.66211 9.27406 4.25043 8.45134 6.47379C7.92958 5.95107 7.20766 5.62707 6.41086 5.62707C4.81774 5.62707 3.52654 6.91827 3.52654 8.51091C3.52654 8.55171 3.53134 8.59107 3.53278 8.63139C1.77358 9.11763 0.47998 10.7251 0.47998 12.6389C0.47998 14.9371 2.34286 16.8 4.64158 16.8C5.03854 16.8 8.63998 16.8 8.63998 16.8" stroke="#235DE9" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.4001 19.6802L12.0001 22.0802L9.6001 19.6802" stroke="#235DE9" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
        <path d="M12 12.48V21.9206" stroke="#235DE9" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_621_560">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

// export function StatsIcon() {
//   return (
//     <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
//       <g id="star-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <g id="Group-22">
//           <rect id="Rectangle" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="24" height="24"></rect>
//           <path
//             d="M16.2743957,17.8832009 L14.8859506,12.9377022 L18.9161175,9.7528172 L13.7836156,9.5450638 L12,4.72796372 L10.2163844,9.5450638 L5.08388251,9.7528172 L9.11404941,12.9377022 L7.72560432,17.8832009 L12,15.034468 L16.2743957,17.8832009 Z"
//             id="Star"
//             stroke="#323842"
//             strokeWidth="1.2"
//           ></path>
//         </g>
//       </g>
//     </svg>
//   )
// }

export function CalenderIcon() {
  return (
    <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="calender-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M9.86666667,7.58666667 L6.95,7.58666667 L6.95,10.5033333 L9.86666667,10.5033333 L9.86666667,7.58666667 Z M9.28333333,1.17 L9.28333333,2.33666667 L4.61666667,2.33666667 L4.61666667,1.17 L3.45,1.17 L3.45,2.33666667 L2.86666667,2.33666667 C2.21916667,2.33666667 1.70583333,2.86166667 1.70583333,3.50333333 L1.7,11.67 C1.7,12.3116667 2.21916667,12.8366667 2.86666667,12.8366667 L11.0333333,12.8366667 C11.675,12.8366667 12.2,12.3116667 12.2,11.67 L12.2,3.50333333 C12.2,2.86166667 11.675,2.33666667 11.0333333,2.33666667 L10.45,2.33666667 L10.45,1.17 L9.28333333,1.17 Z M11.0333333,11.67 L2.86666667,11.67 L2.86666667,5.25333333 L11.0333333,5.25333333 L11.0333333,11.67 Z"
          id="Shape"
          fill="#757A82"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

export const ClockIcon = ClockIconSVG

export function NoteIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.66667 2H15.3333C16.25 2 17 2.75 17 3.66667V12L12 17H3.66667C2.75 17 2 16.25 2 15.3333V3.66667C2 2.75 2.75 2 3.66667 2ZM15.3333 11.1667V3.66667H3.66667V15.3333H11.1667V11.1667H15.3333ZM9.5 11.1667H5.33333V9.5H9.5V11.1667ZM5.33333 7.83333H13.6667V6.16667H5.33333V7.83333Z"
        fill="#757A82"
      />
    </svg>
  )
}

export function TrendingIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9398 9.41527C16.9657 10.2702 18.0184 11.1473 18.5481 12.5281C19.5284 14.8807 18.8632 17.5845 17.0428 19.2787C15.3886 20.7974 13.0869 21.1924 10.9601 20.9203C9.47228 20.7271 5.33258 19.2173 5 14.3014C5 12.0804 5.60389 10.6056 6.19903 9.69269C6.45284 9.31522 7.04797 9.53468 6.99546 9.99116C6.85543 11.2289 7.02172 12.9583 8.60583 14.1609C8.94716 14.4243 9.41977 14.0468 9.26223 13.643C7.34554 8.70951 9.62982 4.94358 12.8068 3.065C13.1394 2.8631 13.5507 3.16156 13.4632 3.54781C12.7372 6.74654 14.3046 8.05264 15.9398 9.41527ZM12.5092 14.9158C12.3342 15.7235 11.6865 16.6364 10.4263 16.9437C12.9643 19.0329 15.3624 17.128 15.2924 14.9071C15.2924 13.9488 14.5556 13.2092 13.8263 12.4771C13.1927 11.8411 12.5647 11.2108 12.4305 10.4476C11.9797 11.6221 12.1915 12.532 12.3794 13.3394C12.5089 13.8959 12.6271 14.4037 12.5092 14.9158Z"
        fill="#045DE9"
      />
    </svg>
  )
}

export function PlaneIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g id="plane-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="heart-icon" transform="translate(4.000000, 4.000000)" fill="#265DE9" fillRule="nonzero">
          <path d="M14.0332587,15.6669593 C14.0158587,15.4326593 12.6364587,6.76893931 12.6364587,6.76893931 C12.6364587,6.75494931 12.6364587,6.74094931 12.6364587,6.73395931 C12.6400587,6.34569931 12.8185587,6.18825931 13.0984587,5.88037931 C13.0984587,5.88037931 15.4810587,3.43479931 16.2402587,2.58463931 C16.9995587,1.73446931 17.1082587,0.786539308 16.6186587,0.296980308 C16.1290587,-0.192583692 15.1881587,-0.0839066922 14.3379587,0.675339308 C13.4878587,1.43457931 11.0422587,3.81720931 11.0422587,3.81720931 C10.7343587,4.09711931 10.5769587,4.27554931 10.1886587,4.27913931 C10.1746587,4.27914931 10.1606587,4.27914931 10.1536587,4.27914931 C10.1536587,4.27914931 1.49350868,2.90327931 1.25565868,2.88234931 C1.01781868,2.86142931 0.661049678,2.83353931 0.297184678,3.19739931 C-0.129657822,3.62424931 -0.0562497224,3.80260931 0.262004678,3.97391931 C0.262004678,3.97391931 6.54662868,7.49456931 6.77394868,7.63091931 C7.00126868,7.76727931 7.02920868,7.92816931 6.80178868,8.18356931 C6.57435868,8.43895931 5.20635868,9.83495931 5.04891868,9.99935931 C4.89146868,10.1638593 4.86349868,10.1428593 4.68859868,10.1568593 L2.14212868,10.4653593 C2.01270868,10.4758593 1.89026868,10.5283593 1.79230868,10.6263593 C1.79230868,10.6263593 1.57888868,10.8397593 1.35846868,11.0601593 C1.13804868,11.2805593 1.20097868,11.4134593 1.47377868,11.5183593 C1.74657868,11.6232593 3.22253868,12.0495593 3.22253868,12.0495593 C3.25750868,12.0635593 3.44986868,12.1439593 3.51280868,12.2068593 C3.65967868,12.3537593 3.79605868,12.4831593 3.60361868,12.7315593 C3.25021868,13.1758593 3.06472868,13.6131593 3.19061868,13.7389593 C3.31649868,13.8648593 3.75377868,13.6793593 4.19808868,13.3259593 C4.44297868,13.1300593 4.57585868,13.2699593 4.72272868,13.4167593 C4.78567868,13.4797593 4.86607868,13.6720593 4.88005868,13.7070593 C4.88005868,13.7070593 5.30640868,15.1830593 5.41126868,15.4558593 C5.51612868,15.7286593 5.64902868,15.7915593 5.86944868,15.5711593 C6.08986868,15.3507593 6.30328868,15.1373593 6.30328868,15.1373593 C6.40124868,15.0393593 6.45724868,14.9134593 6.46427868,14.7874593 L6.77274868,12.2410593 C6.78677868,12.0661593 6.77279868,12.0381593 6.93023868,11.8806593 C7.08767868,11.7232593 8.49065868,10.3552593 8.74604868,10.1278593 C9.00144868,9.90035931 9.16233868,9.92835931 9.29869868,10.1556593 C9.43504868,10.3829593 12.9556587,16.6676593 12.9556587,16.6676593 C13.1304587,16.9893593 13.3053587,17.0592593 13.7322587,16.6324593 C14.0820587,16.2615593 14.0541587,15.9047593 14.0332587,15.6669593 Z"></path>
        </g>
      </g>
    </svg>
  )
}

export function SwapIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 10C20 4.475 15.525 -1.95608e-07 10 -4.37114e-07C4.475 -6.78619e-07 -1.95608e-07 4.475 -4.37114e-07 10C-6.78619e-07 15.525 4.475 20 10 20C15.525 20 20 15.525 20 10ZM13 4.5L16.5 8L13 11.5L13 9L9 9L9 7L13 7L13 4.5ZM7 15.5L3.5 12L7 8.5L7 11L11 11L11 13L7 13L7 15.5Z" fill="#2E9306" />
    </svg>
  )
}

// export function RankIcon() {
//   return (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M17 10.43V2H7V10.43C7 10.78 7.18 11.11 7.49 11.29L11.67 13.8L10.68 16.14L7.27 16.43L9.86 18.67L9.07 22L12 20.23L14.93 22L14.15 18.67L16.74 16.43L13.33 16.14L12.34 13.8L16.52 11.29C16.82 11.11 17 10.79 17 10.43ZM11 11.07L9 9.87V4H11V11.07ZM13 11.07L15 9.87V4H13V11.07Z"
//         fill="#245FE7"
//       />
//     </svg>
//   )
// }

// export function FacebookBrand() {
//   return (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path
//         d="M20.2 1H3.40001C2.08001 1 1 2.08 1 3.4V20.2C1 21.5211 2.08001 22.5999 3.40001 22.5999H11.8V14.2H9.39999V11.2299H11.8V8.77C11.8 6.1732 13.2544 4.3492 16.3192 4.3492L18.4828 4.3516V7.4776H17.0464C15.8536 7.4776 15.4 8.3728 15.4 9.2032V11.2312H18.4816L17.8 14.2H15.4V22.5999H20.2C21.52 22.5999 22.6 21.5211 22.6 20.2V3.4C22.6 2.08 21.52 1 20.2 1Z"
//         fill="white"
//       />
//     </svg>
//   )
// }

// export function GoogleBrand() {
//   return (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path
//         d="M22.4882 12.207C22.4882 11.3055 22.415 10.6477 22.2567 9.96558H11.9634V14.0341H18.0054C17.8836 15.0452 17.2258 16.5679 15.764 17.5911L15.7435 17.7273L18.9981 20.2486L19.2235 20.2711C21.2944 18.3586 22.4882 15.5447 22.4882 12.207"
//         fill="#4285F4"
//       />
//       <path
//         d="M11.9634 22.9267C14.9234 22.9267 17.4084 21.9521 19.2235 20.2711L15.764 17.5911C14.8382 18.2368 13.5957 18.6875 11.9634 18.6875C9.06421 18.6875 6.60356 16.775 5.72641 14.1317L5.59784 14.1426L2.21369 16.7616L2.16943 16.8846C3.97228 20.466 7.67546 22.9267 11.9634 22.9267"
//         fill="#34A853"
//       />
//       <path
//         d="M5.72637 14.1317C5.49493 13.4495 5.36098 12.7186 5.36098 11.9633C5.36098 11.208 5.49493 10.4772 5.7142 9.79503L5.70807 9.64975L2.28151 6.98865L2.1694 7.04197C1.42636 8.52813 1 10.197 1 11.9633C1 13.7297 1.42636 15.3985 2.1694 16.8846L5.72637 14.1317"
//         fill="#FBBC05"
//       />
//       <path
//         d="M11.9634 5.23913C14.022 5.23913 15.4107 6.12838 16.2025 6.8715L19.2966 3.85047C17.3963 2.08416 14.9234 1 11.9634 1C7.67546 1 3.97228 3.46064 2.16943 7.04197L5.71423 9.79503C6.60356 7.15165 9.06421 5.23913 11.9634 5.23913"
//         fill="#EB4335"
//       />
//     </svg>
//   )
// }

export function NotificationIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="notification-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M17.15625,13.3258732 L17.15625,10.8154727 C17.1538875,8.50596697 15.4705439,6.5348339 13.171875,6.14991726 L13.171875,5.28943409 C13.171875,4.85344168 12.8151019,4.5 12.375,4.5 C11.9348981,4.5 11.578125,4.85344168 11.578125,5.28943409 L11.578125,6.14991726 C9.27945615,6.5348339 7.5961125,8.50596697 7.59375,10.8154727 L7.59375,13.3258732 C6.6409037,13.6596051 6.00284036,14.5508737 6,15.5520773 L6,17.1309455 C6,17.5669379 6.35677309,17.9203796 6.796875,17.9203796 L9.2990625,17.9203796 C9.6763014,19.2955425 10.9365289,20.25 12.375,20.25 C13.8134711,20.25 15.0736986,19.2955425 15.4509375,17.9203796 L17.953125,17.9203796 C18.3932269,17.9203796 18.75,17.5669379 18.75,17.1309455 L18.75,15.5520773 C18.7471597,14.5508737 18.1090963,13.6596051 17.15625,13.3258732 Z M9.1875,10.8154727 C9.1875,9.07150312 10.6145924,7.6577364 12.375,7.6577364 C14.1354076,7.6577364 15.5625,9.07150312 15.5625,10.8154727 L15.5625,14.7626432 L9.1875,14.7626432 L9.1875,10.8154727 Z M12.375,18.7098137 C11.8090417,18.7064294 11.287349,18.4059519 11.004375,17.9203796 L13.745625,17.9203796 C13.4626511,18.4059519 12.9409583,18.7064294 12.375,18.7098137 Z M17.15625,16.3415114 L7.59375,16.3415114 L7.59375,15.5520773 C7.59375,15.1160849 7.95052313,14.7626432 8.390625,14.7626432 L16.359375,14.7626432 C16.7994769,14.7626432 17.15625,15.1160849 17.15625,15.5520773 L17.15625,16.3415114 Z"
          id="Icon-Shape"
          fill="#FFFFFF"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

export function SearchIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="search-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M20.0183209,18.8589878 L16.9593919,15.8224889 C19.4248508,12.7460903 19.0575803,8.27767443 16.1229438,5.6457981 C13.1883073,3.01392177 8.70988044,3.13656061 5.92345337,5.92510459 C3.1370263,8.71364857 3.01448056,13.1954778 5.64435892,16.1323438 C8.27423727,19.0692098 12.739261,19.4367593 15.8133241,16.9694273 L18.8475179,20.0059263 C19.0023332,20.1621349 19.2130743,20.25 19.4329194,20.25 C19.6527645,20.25 19.8635057,20.1621349 20.0183209,20.0059263 C20.3272264,19.6861065 20.3272264,19.1788076 20.0183209,18.8589878 L20.0183209,18.8589878 Z M11.1878276,16.9694273 C8.00028066,16.9694273 5.41626331,14.3834469 5.41626331,11.1934783 C5.41626331,8.00350969 8.00028066,5.41752921 11.1878276,5.41752921 C14.3753745,5.41752921 16.9593919,8.00350969 16.9593919,11.1934783 C16.9593919,14.3834469 14.3753745,16.9694273 11.1878276,16.9694273 L11.1878276,16.9694273 Z"
          id="Icon-Shape"
          fill="#FFFFFF"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

export function VideoIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="video-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z M9.5,6.70637146 C8.67157288,6.70637146 8,7.37794434 8,8.20637146 L8,8.20637146 L8,15.2936285 C8,15.5747581 8.07900417,15.8502295 8.22800254,16.0886269 C8.66706804,16.7911317 9.59249361,17.0046915 10.2949984,16.565626 L10.2949984,16.565626 L15.9648041,13.0219975 C16.1579578,12.9012764 16.3210821,12.7381521 16.4418031,12.5449984 C16.8808686,11.8424936 16.6673089,10.917068 15.9648041,10.4780025 L15.9648041,10.4780025 L10.2949984,6.93437401 C10.056601,6.78537563 9.78112957,6.70637146 9.5,6.70637146 Z"
          id="Combined-Shape"
          fill="#34353D"
        ></path>
      </g>
    </svg>
  )
}

export function ShareIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="share-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M13.4,8.64 L13.4,4.8 L20.4,11.52 L13.4,18.24 L13.4,14.304 C8.4,14.304 4.9,15.84 2.4,19.2 C3.4,14.4 6.4,9.6 13.4,8.64 Z"
          fill="#FFFFFF"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

export function MenuIcon() {
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="menu-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="ic_search" fillRule="nonzero">
          <rect id="ViewBox" x="0" y="0" width="32" height="32"></rect>
        </g>
        <g id="Group">
          <rect id="Rectangle" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="32" height="32"></rect>
          <path
            d="M27,20.8 L25.7150442,24 L5,24 L6.28495575,20.8 L27,20.8 Z M27,14.4 L27,17.6 L5,17.6 L5,14.4 L27,14.4 Z M27,8 L25.7150442,11.2 L5,11.2 L6.28495575,8 L27,8 Z"
            id="Shape"
            fill="#FFFFFF"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export function EditIcon() {
  return (
    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="edit-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-50">
          <rect id="Rectangle" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="20" height="20"></rect>
          <g
            id="Group-16"
            transform="translate(10.383022, 10.821394) rotate(40.000000) translate(-10.383022, -10.821394) translate(6.883022, 3.321394)"
            stroke="#FFFFFF"
            strokeWidth="2"
          >
            <path
              d="M1.01069022,1 L1.11937718,11.2210054 L3.03085882,13.486039 L5.11911352,11.2068446 L5.01057715,1 L1.01069022,1 Z"
              id="Rectangle"
            ></path>
            <path d="M1,1 L1,4 L5,4 L5,1 L1,1 Z" id="Rectangle-Copy-6"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function CloseIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="close-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon
          fill="#23272E"
          fillRule="nonzero"
          points="18.6398758 20 12.504799 13.8592679 6.36977052 20 5 18.6311041 11.1446748 12.5000121 5 6.3688911 6.36977052 5 12.504799 11.1407562 18.6398758 5.00964011 20 6.3688911 13.8649233 12.5000121 20 18.6311041"
        ></polygon>
      </g>
    </svg>
  )
}

export const ViewIcon = ViewIconSVG

// export function ClapIcon() {
//   return (
//     <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
//       <defs>
//         <polygon
//           id="path-1"
//           points="0.00435120977 0.00455729167 1.87672234 0.00455729167 1.87672234 2.04002604 0.00435120977 2.04002604"
//         ></polygon>
//         <polygon id="path-3" points="0.00109375 0.0116339984 2.15935687 0.0116339984 2.15935687 1.79373177 0.00109375 1.79373177"></polygon>
//       </defs>
//       <g id="clap-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <path
//           d="M9.1132474,11.8288203 C9.05259896,11.8288203 8.99195052,11.8056875 8.9456849,11.7594219 L8.01823958,10.8319766 C7.67013542,10.4838724 7.67013542,9.91749219 8.01823958,9.56938802 C8.36634375,9.22128385 8.93272396,9.22128385 9.28082812,9.56938802 L10.3628385,10.6514167 C10.455388,10.7439479 10.455388,10.8940104 10.3628385,10.9865417 C10.2702891,11.0791094 10.120263,11.0791094 10.0276953,10.9865417 L8.9456849,9.90453125 C8.78238802,9.74123438 8.51667969,9.74123438 8.35338281,9.90453125 C8.27477865,9.98311719 8.2315026,10.0882995 8.2315026,10.2006823 C8.2315026,10.3130651 8.27477865,10.4182474 8.35338281,10.4968333 L9.28082812,11.4242786 C9.37335937,11.5168281 9.37335937,11.6668724 9.28082812,11.7594219 C9.23454427,11.8056875 9.17389583,11.8288203 9.1132474,11.8288203"
//           id="Fill-10"
//           fill="#1B1A19"
//         ></path>
//         <path
//           d="M12.3593151,13.2199974 C12.2986484,13.2199974 12.2380182,13.1968646 12.1917344,13.1505807 L9.87313021,10.8319766 C9.52502604,10.4838724 9.52502604,9.91749219 9.87313021,9.56938802 C10.2212344,9.22128385 10.7876146,9.22128385 11.1357188,9.56938802 L13.7634714,12.1971589 C13.8560208,12.2896901 13.8560208,12.4397526 13.7634714,12.5322839 C13.6709219,12.6248333 13.5208776,12.6248333 13.4283281,12.5322839 L10.8005755,9.90453125 C10.6372786,9.74123438 10.3715703,9.74123438 10.2082734,9.90453125 C10.0449766,10.0678281 10.0449766,10.3335365 10.2082734,10.4968333 L12.5268776,12.8154557 C12.6194271,12.907987 12.6194271,13.0580495 12.5268776,13.1505807 C12.4805938,13.1968646 12.4199635,13.2199974 12.3593151,13.2199974"
//           id="Fill-11"
//           fill="#1B1A19"
//         ></path>
//         <path
//           d="M10.5044245,15.074888 C10.443776,15.074888 10.3831276,15.0517552 10.3368437,15.0054714 L7.70909115,12.3777188 C7.36098698,12.0296146 7.36098698,11.4632344 7.70909115,11.1151302 C8.05719531,10.767026 8.62357552,10.767026 8.97167969,11.1151302 L11.5994323,13.7428828 C11.6919818,13.8354323 11.6919818,13.9854948 11.5994323,14.078026 C11.5068828,14.1705755 11.3568385,14.1705755 11.2642891,14.078026 L8.63653646,11.4502734 C8.47323958,11.2869766 8.20753125,11.2869766 8.04423437,11.4502734 C7.8809375,11.6135703 7.8809375,11.8792786 8.04423437,12.0425755 L10.671987,14.6703281 C10.7645365,14.7628776 10.7645365,14.9129401 10.671987,15.0054714 C10.6257214,15.0517552 10.5650729,15.074888 10.5044245,15.074888"
//           id="Fill-12"
//           fill="#1B1A19"
//         ></path>
//         <path
//           d="M13.5958906,18.6613854 C12.6955156,18.6613854 11.7951589,18.3186771 11.109724,17.6332422 L7.70909115,14.2326094 C7.54098177,14.0645 7.44839583,13.8402995 7.44839583,13.6013151 C7.44839583,13.3623307 7.54098177,13.1381302 7.70909115,12.9700208 C7.87720052,12.8019115 8.10140104,12.7093255 8.34038542,12.7093255 C8.57936979,12.7093255 8.80357031,12.8019115 8.97167969,12.9700208 C9.06421094,13.0625703 9.06421094,13.2126146 8.97167969,13.3051641 C8.87913021,13.3977135 8.72908594,13.3977135 8.63653646,13.3051641 C8.47323958,13.1418672 8.20753125,13.1418672 8.04423437,13.3051641 C7.8809375,13.4684609 7.8809375,13.7341693 8.04423437,13.8974661 L11.4448672,17.298099 C12.6309479,18.4841615 14.5608698,18.4841979 15.7469505,17.298099 C16.3215156,16.7235339 16.6379375,15.9596042 16.6379375,15.1470573 C16.6379375,14.3344922 16.3215156,13.5705807 15.7469505,12.9960156 L13.7374766,10.9865417 C13.699651,10.9487344 13.649375,10.9278984 13.5959089,10.9278984 C13.5424245,10.9278984 13.4921484,10.9487344 13.4543229,10.9865417 C13.2057865,11.2350781 13.2057865,11.639474 13.4543229,11.8880104 L14.8454818,13.2791693 C14.9380312,13.3717187 14.9380312,13.521763 14.8454818,13.6143125 C14.7529323,13.706862 14.6029062,13.706862 14.5103568,13.6143125 L13.1191797,12.2231354 C12.6858542,11.7898099 12.6858542,11.0847422 13.1191797,10.6514167 C13.3820443,10.3885521 13.8097552,10.3885521 14.0726198,10.6514167 L16.0820755,12.6608724 C16.7461641,13.3249609 17.1118958,14.2078906 17.1118958,15.1470391 C17.1118958,16.0862057 16.7461641,16.9691354 16.0820755,17.633224 C15.3966406,18.3186771 14.4962656,18.6613854 13.5958906,18.6613854"
//           id="Fill-13"
//           fill="#1B1A19"
//         ></path>
//         <path
//           d="M12.068888,9.8013724 C12.0082214,9.8013724 11.9475911,9.77823958 11.9013073,9.73197396 L10.8192969,8.64994531 C10.656,8.48664844 10.3902734,8.48664844 10.2269766,8.64994531 C10.0636797,8.81324219 10.0636797,9.07895052 10.2269766,9.2422474 L10.3628385,9.37809115 C10.455388,9.47064062 10.455388,9.6206849 10.3628568,9.71323438 C10.2702891,9.80578385 10.1202448,9.80578385 10.0277135,9.7132526 L9.89185156,9.57740885 C9.5437474,9.22928646 9.5437474,8.66290625 9.89185156,8.31480208 C10.2399375,7.96671615 10.8063359,7.96671615 11.1544219,8.31480208 L12.2364505,9.39683073 C12.329,9.48938021 12.329,9.63942448 12.2364505,9.73197396 C12.1901667,9.77823958 12.1295365,9.8013724 12.068888,9.8013724"
//           id="Fill-14"
//           fill="#1B1A19"
//         ></path>
//         <path
//           d="M15.4695026,11.3471146 C15.4088542,11.3471146 15.348224,11.3239818 15.3019401,11.2777161 L12.6741875,8.64994531 C12.5108906,8.48664844 12.2451641,8.48664844 12.0818672,8.64994531 C11.9185703,8.81324219 11.9185703,9.07895052 12.0818672,9.2422474 L13.4674479,10.6278281 C13.5599792,10.7203594 13.5599792,10.8704219 13.4674479,10.9629531 C13.3748984,11.0555208 13.2248542,11.0555208 13.1323047,10.9629531 L11.7467422,9.57739062 C11.398638,9.22928646 11.398638,8.66290625 11.7467422,8.31480208 C12.0948281,7.96671615 12.6612266,7.96671615 13.0093125,8.31480208 L15.6370833,10.9425729 C15.7296146,11.0351042 15.7296146,11.1851667 15.6370833,11.2777161 C15.5907995,11.3239818 15.530151,11.3471146 15.4695026,11.3471146"
//           id="Fill-15"
//           fill="#1B1A19"
//         ></path>
//         <path
//           d="M16.2438229,17.3162187 C16.1369271,17.3162187 16.0399297,17.2434115 16.0136797,17.1349297 C15.9828906,17.0077266 16.0610573,16.8796484 16.1882604,16.8488594 C16.729375,16.717901 17.2246432,16.4394141 17.6205443,16.043513 C18.8066432,14.8574323 18.8066432,12.9275104 17.6205443,11.7414297 L15.6110885,9.73197396 C15.5330313,9.65389844 15.4059922,9.65389844 15.3279349,9.73197396 C15.0793984,9.98049219 15.0793984,10.384888 15.3279349,10.6334245 L16.7190938,12.0245833 C16.8116432,12.1171328 16.8116432,12.2671771 16.7190938,12.3597266 C16.6265443,12.452276 16.4765182,12.452276 16.3839505,12.3597266 L14.9927917,10.9685677 C14.5594661,10.5352422 14.5594661,9.83015625 14.9927917,9.39683073 C15.2556563,9.13396615 15.6833672,9.13396615 15.9462318,9.39683073 L17.9556875,11.4062865 C18.619776,12.070375 18.9855078,12.9533229 18.9855078,13.8924714 C18.9855078,14.8316198 18.619776,15.7145677 17.9556875,16.378638 C17.4981719,16.8361536 16.9255573,17.1580625 16.29975,17.3095104 C16.2810286,17.3140495 16.2622708,17.3162187 16.2438229,17.3162187"
//           id="Fill-16"
//           fill="#1B1A19"
//         ></path>
//         <path
//           d="M9.34339062,7.89383594 C9.26261719,7.89383594 9.18386719,7.85251042 9.13955208,7.77804427 L8.6777526,7.00233854 C8.61079687,6.88988281 8.64769271,6.74443229 8.76016667,6.67749479 C8.8726224,6.61055729 9.01807292,6.6474349 9.08501042,6.75989063 L9.54679167,7.53559635 C9.6137474,7.64805208 9.57685156,7.79348437 9.46439583,7.8604401 C9.42640625,7.8830625 9.384625,7.89383594 9.34339062,7.89383594"
//           id="Fill-17"
//           fill="#1B1A19"
//         ></path>
//         <g id="Group-21" transform="translate(9.739583, 5.500000)">
//           <mask id="mask-2" fill="white">
//             <use xlinkHref="#path-1"></use>
//           </mask>
//           <g id="Clip-19"></g>
//           <path
//             d="M1.6396224,1.79890885 C1.51218229,1.79890885 1.40692708,1.69768229 1.40288021,1.56940365 L1.37442448,0.667096354 C1.37030469,0.536265625 1.47300781,0.426890625 1.60382031,0.422752604 C1.73448698,0.418523438 1.84400781,0.521335937 1.84814583,0.652148437 L1.87660156,1.55445573 C1.88073958,1.68526823 1.77803646,1.79466146 1.64722396,1.79879948 C1.64467187,1.7988724 1.64213802,1.79890885 1.6396224,1.79890885"
//             id="Fill-18"
//             fill="#1B1A19"
//             mask="url(#mask-2)"
//           ></path>
//           <path
//             d="M0.604989583,2.04002604 C0.497309896,2.04002604 0.399893229,1.96614323 0.374408854,1.85676823 L0.0105911458,0.295385417 C-0.0191223958,0.167908854 0.0601380208,0.0405052083 0.187596354,0.0108098958 C0.315054688,-0.0189583333 0.442476563,0.060375 0.472171875,0.187815104 L0.835989583,1.74919792 C0.865684896,1.87667448 0.786442708,2.00407812 0.658984375,2.03377344 C0.640882812,2.0380026 0.622799479,2.04002604 0.604989583,2.04002604"
//             id="Fill-20"
//             fill="#1B1A19"
//             mask="url(#mask-2)"
//           ></path>
//         </g>
//         <path
//           d="M5.98448438,13.1147604 C5.87649479,13.1147604 5.77889583,13.0404583 5.75372135,12.9307188 C5.72446354,12.803151 5.80414323,12.6760208 5.93171094,12.646763 L6.81161458,12.4448932 C6.9391276,12.4156719 7.06633073,12.4953151 7.09558854,12.622901 C7.12484635,12.7504688 7.04516667,12.877599 6.91759896,12.9068568 L6.03769531,13.1087083 C6.01986719,13.1128099 6.00203906,13.1147604 5.98448438,13.1147604"
//           id="Fill-22"
//           fill="#1B1A19"
//         ></path>
//         <g id="Group-26" transform="translate(5.000000, 10.057292)">
//           <mask id="mask-4" fill="white">
//             <use xlinkHref="#path-3"></use>
//           </mask>
//           <g id="Clip-24"></g>
//           <path
//             d="M1.92242969,0.735127604 C1.90075521,0.735127604 1.87871615,0.732119792 1.85684115,0.725848958 L0.989223958,0.476419271 C0.863442708,0.440252604 0.79078125,0.308984375 0.826947917,0.183184896 C0.863096354,0.0574036458 0.994401042,-0.0152213542 1.12018229,0.0209088542 L1.98779948,0.270320312 C2.11358073,0.306486979 2.18622396,0.437773437 2.15007552,0.563554687 C2.12019792,0.667460938 2.02540625,0.735127604 1.92242969,0.735127604"
//             id="Fill-23"
//             fill="#1B1A19"
//             mask="url(#mask-4)"
//           ></path>
//           <path
//             d="M1.8350026,1.79373177 C1.8284401,1.79373177 1.82185937,1.79345833 1.81520573,1.79291146 L0.217455729,1.66073177 C0.0870260417,1.6499401 -0.00997135417,1.53546094 0.0008203125,1.40503125 C0.0116119792,1.27460156 0.126127604,1.17767708 0.256520833,1.18839583 L1.85427083,1.32057552 C1.98471875,1.33134896 2.08169792,1.44584635 2.07090625,1.57627604 C2.06067969,1.70007031 1.95702865,1.79373177 1.8350026,1.79373177"
//             id="Fill-25"
//             fill="#1B1A19"
//             mask="url(#mask-4)"
//           ></path>
//         </g>
//       </g>
//     </svg>
//   )
// }

// export function CommentIcon() {
//   return (
//     <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
//       <g id="comment-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <path
//           d="M7,7 L7,13.0572248 L8.42857143,13.0572248 L8.42857143,14.9856938 L9.00892857,14.4886076 L10.6942857,13.0572248 L14.1428571,13.0572248 L14.1428571,7 L7,7 Z M7.71428571,7.7571531 L13.4285714,7.7571531 L13.4285714,12.3000717 L10.4485714,12.3000717 L10.3482286,12.3829951 L9.14285714,13.4002152 L9.14285714,12.3000717 L7.71428571,12.3000717 L7.71428571,7.7571531 Z M14.8571429,8.51430621 L14.8571429,9.27145931 L16.2857143,9.27145931 L16.2857143,13.8143779 L14.8571429,13.8143779 L14.8571429,14.9145214 L13.5514286,13.8143779 L10.8728571,13.8143779 L9.98,14.571531 L13.3057143,14.571531 L15.5714286,16.5 L15.5714286,14.571531 L17,14.571531 L17,8.51430621 L14.8571429,8.51430621 Z"
//           id="Shape"
//           fill="#23272E"
//           fillRule="nonzero"
//         ></path>
//       </g>
//     </svg>
//   )
// }

export function SaveIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="save-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M9,7 L9,16.6384102 L12,14.9241244 L15,16.6384102 L15,7 L9,7 Z" id="Rectangle" stroke="#323842"></path>
      </g>
    </svg>
  )
}

// export function BigTextIcon() {
//   return (
//     <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
//       <g id="big-text-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <path
//           d="M6.94016667,14 L7.40916667,12.558 L9.19416667,12.558 L9.66316667,14 L10.4751667,14 L8.72516667,8.981 L7.88516667,8.981 L6.12816667,14 L6.94016667,14 Z M8.99116667,11.9 L7.62616667,11.9 L8.08816667,10.493 C8.11616667,10.395 8.15,10.2725 8.18966667,10.1255 C8.22933333,9.9785 8.2655,9.82566667 8.29816667,9.667 C8.3215,9.74166667 8.34716667,9.83383333 8.37516667,9.9435 C8.40316667,10.0531667 8.43233333,10.1581667 8.46266667,10.2585 C8.493,10.3588333 8.51516667,10.437 8.52916667,10.493 L8.52916667,10.493 L8.99116667,11.9 Z M12.6928333,14 L13.2958333,12.146 L15.5908333,12.146 L16.1938333,14 L17.2378333,14 L14.9878333,7.547 L13.9078333,7.547 L11.6488333,14 L12.6928333,14 Z M15.3298333,11.3 L13.5748333,11.3 L14.1688333,9.491 C14.2048333,9.365 14.2483333,9.2075 14.2993333,9.0185 C14.3503333,8.8295 14.3968333,8.633 14.4388333,8.429 C14.4688333,8.525 14.5018333,8.6435 14.5378333,8.7845 C14.5738333,8.9255 14.6113333,9.0605 14.6503333,9.1895 C14.6893333,9.3185 14.7178333,9.419 14.7358333,9.491 L14.7358333,9.491 L15.3298333,11.3 Z"
//           id="AA"
//           fill="#23272E"
//           fillRule="nonzero"
//         ></path>
//       </g>
//     </svg>
//   )
// }

export function FilterIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="filter-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M12,14.1972244 L18.1314829,5 L5.86851709,5 L12,14.1972244 Z" id="Rectangle" stroke="#50555D" strokeWidth="2"></path>
        <line x1="11.995" y1="14" x2="11.995" y2="20" id="Path-7" stroke="#50555D" strokeWidth="2" strokeLinecap="round"></line>
      </g>
    </svg>
  )
}

export function AnnouncementIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8 4.8L19.8 4.80002C20 5.06751 20.2 5.33501 20.4 5.6C19.7287 6.10855 18.9379 6.69985 18.199 7.25234L18.1986 7.25261L18.1978 7.25325L18.1977 7.25334C17.8473 7.51529 17.5087 7.7685 17.2 8C17 7.735 16.8 7.4675 16.6 7.2L16.5998 7.19967L16.5997 7.19964C16.3998 6.93226 16.1999 6.66488 16 6.4C16.3077 6.1692 16.6453 5.9158 16.9945 5.65363L16.9959 5.65252L16.9986 5.65055C17.7376 5.09572 18.5286 4.50186 19.2 4C19.3996 4.26446 19.5992 4.5314 19.7988 4.79835L19.8 4.79998L19.8 4.8ZM22 11H18V13H22V11ZM18.2811 19.3122L18.282 19.3128L18.2826 19.3133C18.6014 19.5521 18.9117 19.7845 19.2 20C19.4 19.735 19.6 19.4675 19.8 19.2C20 18.9325 20.2 18.665 20.4 18.4C19.7287 17.8982 18.9378 17.3044 18.1989 16.7497L18.1985 16.7494C17.8478 16.4861 17.5089 16.2317 17.2 16C16.8 16.54 16.4 17.08 16 17.61C16.68 18.1129 17.5055 18.7313 18.2811 19.3122ZM2 11C2 9.9 2.9 9 4 9H8L13 6V18L8 15H7V19H5V15H4C2.9 15 2 14.1 2 13V11ZM11 9.53L9.03 10.71L8.55 11H8H4V13H8H8.55L9.03 13.29L11 14.47V9.53ZM14 8.65C14.92 9.47 15.5 10.67 15.5 12C15.5 13.33 14.92 14.53 14 15.34V8.65Z"
        fill="#323842"
      />
    </svg>
  )
}

export function HelmetIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.68531 19.5678L4.44531 19.8498L4.35665 18.2632L7.51531 17.8032L7.42665 18.7378C7.42665 19.1972 7.05598 19.5678 6.68531 19.5678ZM7.61931 15.5785L7.51531 16.9652L4.35665 17.3432L4.26731 15.9418L7.61931 15.5785ZM9.93331 14.4592C9.47331 13.6205 9.19131 12.6938 8.90998 11.5738H8.73131C8.82065 12.2265 8.64265 13.2498 8.53865 14.5552L9.93331 14.4592ZM7.79731 11.7598C6.49265 11.8558 5.46865 12.1378 4.16398 12.2265C1.83531 -1.06151 23.5326 -0.231507 21.5753 13.0645C21.664 13.7172 20.9226 13.6205 19.8993 13.5318C17.9413 17.8918 13.1066 18.7378 10.4966 15.2965L8.53865 15.4818L8.36065 18.8265C8.25731 19.6565 7.61931 20.3985 6.77398 20.5025L4.07465 20.8732C3.98598 20.8732 3.79331 20.7838 3.70398 20.6805C3.61531 20.6805 3.51131 20.5025 3.51131 20.3985L3.33331 15.5785C3.33331 15.3858 3.51131 15.2005 3.70398 15.1112L7.61931 14.6438C7.70798 13.3392 7.61931 12.4118 7.79731 11.7598V11.7598Z"
        fill="#045DE9"
      />
    </svg>
  )
}

export function WarningIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="warning-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M11.9376454,4.097 L20.9736454,19.709 L2.90164544,19.709 L11.9376454,4.097 M0.825645442,18.509 C-0.0983545581,20.105 1.05364544,22.109 2.90164544,22.109 L20.9736454,22.109 C22.8216454,22.109 23.9736454,20.105 23.0496454,18.509 L14.0136454,2.897 C13.0896454,1.301 10.7856454,1.301 9.86164544,2.897 L0.825645442,18.509 Z M10.7376454,10.109 L10.7376454,12.509 C10.7376454,13.169 11.2776454,13.709 11.9376454,13.709 C12.5976454,13.709 13.1376454,13.169 13.1376454,12.509 L13.1376454,10.109 C13.1376454,9.449 12.5976454,8.909 11.9376454,8.909 C11.2776454,8.909 10.7376454,9.449 10.7376454,10.109 Z M10.7376454,16.109 L13.1376454,16.109 L13.1376454,18.509 L10.7376454,18.509 L10.7376454,16.109 Z"
          id="shape"
          fill="#045DE9"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

export function PlaylistIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="playlist-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M16,13 L22,17 L16,21 L16,13 Z M10,14 L10,16 L3,16 L3,14 L10,14 Z M14,10 L14,12 L3,12 L3,10 L14,10 Z M14,6 L14,8 L3,8 L3,6 L14,6 Z"
          id="Combined-Shape"
          fill="#F2F4F7"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

export function MapIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="map-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M12,2 C8.13,2 5,5.13 5,9 C5,14.25 12,22 12,22 C12,22 19,14.25 19,9 C19,5.13 15.87,2 12,2 Z M12,11.5 C10.62,11.5 9.5,10.38 9.5,9 C9.5,7.62 10.62,6.5 12,6.5 C13.38,6.5 14.5,7.62 14.5,9 C14.5,10.38 13.38,11.5 12,11.5 Z"
          id="Shape"
          fill="#50555D"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

export function MailIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="mail-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M20,4 L4,4 C2.9,4 2.01,4.9 2.01,6 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L22,6 C22,4.9 21.1,4 20,4 Z M20,8 L12,13 L4,8 L4,6 L12,11 L20,6 L20,8 Z"
          id="Shape"
          fill="#045DE9"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

export function VerifiedIcon() {
  return (
    <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Crictracker_Profile" transform="translate(-568.000000, -426.000000)" fill="#5C9E31">
          <g id="Rectangle" transform="translate(185.000000, 288.000000)">
            <g id="Group" transform="translate(383.666530, 138.666664)">
              <path
                d="M7.33333558,2.84217094e-14 C3.28333137,2.84217094e-14 0,3.28333137 0,7.33333558 C0,11.3833566 3.28333137,14.6666408 7.33333558,14.6666408 C11.3833229,14.6666408 14.6666914,11.3833566 14.6666914,7.33333558 C14.6666914,3.28333137 11.3833229,2.84217094e-14 7.33333558,2.84217094e-14 Z M10.5119966,6.09333558 C10.5705229,6.02643032 10.6150703,5.94849347 10.6430282,5.86411453 C10.6709861,5.77973558 10.6818493,5.69060716 10.6748598,5.60199242 C10.6678703,5.51336926 10.6431966,5.42704505 10.6023545,5.34808926 C10.5615124,5.26912505 10.505344,5.19913768 10.4370493,5.14222821 C10.3687545,5.08531874 10.2897651,5.04264084 10.2047124,5.016704 C10.119744,4.99077558 10.0303124,4.98211032 9.94189137,4.99122189 C9.85347032,5.00032505 9.767744,5.02702821 9.68984926,5.06975663 C9.61187032,5.11247663 9.54323874,5.17036295 9.48799663,5.23999663 L6.62133558,8.67935663 L5.13800084,7.19533137 C5.01226611,7.07389137 4.84386189,7.00669979 4.66906611,7.00821558 C4.49427032,7.00973979 4.32706189,7.07984505 4.20345768,7.20345768 C4.07984505,7.32706189 4.00973979,7.49427032 4.00819048,7.66906611 C4.00669979,7.843904 4.07389137,8.01224084 4.19533137,8.13796716 L6.19533137,10.1379672 C6.26083874,10.2034829 6.339264,10.2545987 6.42561347,10.2880303 C6.51195453,10.3215461 6.60433347,10.3366198 6.69684716,10.3324093 C6.78936084,10.3281987 6.87997979,10.3047882 6.962944,10.2636093 C7.04589979,10.2224303 7.11936505,10.1644935 7.17866611,10.0933356 L10.5119966,6.09333558 Z"
                id="verified-icon"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function LikeIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="like-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M19.6666667,9.83333333 L14.4083333,9.83333333 L15.2,6.025 L15.225,5.75833333 C15.225,5.41666667 15.0833333,5.1 14.8583333,4.875 L13.975,4 L8.49166667,9.49166667 C8.18333333,9.79166667 8,10.2083333 8,10.6666667 L8,19 C8,19.9166667 8.75,20.6666667 9.66666667,20.6666667 L17.1666667,20.6666667 C17.8583333,20.6666667 18.45,20.25 18.7,19.65 L21.2166667,13.775 C21.2916667,13.5833333 21.3333333,13.3833333 21.3333333,13.1666667 L21.3333333,11.5 C21.3333333,10.5833333 20.5833333,9.83333333 19.6666667,9.83333333 Z M19.6666667,13.1666667 L17.1666667,19 L9.66666667,19 L9.66666667,10.6666667 L13.2833333,7.05 L12.3583333,11.5 L19.6666667,11.5 L19.6666667,13.1666667 Z M3,10.6666667 L6.33333333,10.6666667 L6.33333333,20.6666667 L3,20.6666667 L3,10.6666667 Z"
          id="Shape"
          fill="#23272E"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

export function DislikeIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="dislike-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M19.6666667,9.83333333 L14.4083333,9.83333333 L15.2,6.025 L15.225,5.75833333 C15.225,5.41666667 15.0833333,5.1 14.8583333,4.875 L13.975,4 L8.49166667,9.49166667 C8.18333333,9.79166667 8,10.2083333 8,10.6666667 L8,19 C8,19.9166667 8.75,20.6666667 9.66666667,20.6666667 L17.1666667,20.6666667 C17.8583333,20.6666667 18.45,20.25 18.7,19.65 L21.2166667,13.775 C21.2916667,13.5833333 21.3333333,13.3833333 21.3333333,13.1666667 L21.3333333,11.5 C21.3333333,10.5833333 20.5833333,9.83333333 19.6666667,9.83333333 Z M19.6666667,13.1666667 L17.1666667,19 L9.66666667,19 L9.66666667,10.6666667 L13.2833333,7.05 L12.3583333,11.5 L19.6666667,11.5 L19.6666667,13.1666667 Z M3,10.6666667 L6.33333333,10.6666667 L6.33333333,20.6666667 L3,20.6666667 L3,10.6666667 Z"
          id="Shape"
          fill="#23272E"
          fillRule="nonzero"
          transform="translate(12.166667, 12.333333) scale(1, -1) translate(-12.166667, -12.333333) "
        ></path>
      </g>
    </svg>
  )
}

export function ActionIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="actiondot-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M12,17 C13.1045695,17 14,17.8954305 14,19 C14,20.1045695 13.1045695,21 12,21 C10.8954305,21 10,20.1045695 10,19 C10,17.8954305 10.8954305,17 12,17 Z M12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 Z M12,3 C13.1045695,3 14,3.8954305 14,5 C14,6.1045695 13.1045695,7 12,7 C10.8954305,7 10,6.1045695 10,5 C10,3.8954305 10.8954305,3 12,3 Z"
          id="Combined-Shape"
          fill="#23272E"
        ></path>
      </g>
    </svg>
  )
}

export function PasswordPhoneIcon() {
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="password-phone-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M22.6666667,1.34666667 L9.33333333,1.33333333 C7.86666667,1.33333333 6.66666667,2.53333333 6.66666667,4 L6.66666667,28 C6.66666667,29.4666667 7.86666667,30.6666667 9.33333333,30.6666667 L22.6666667,30.6666667 C24.1333333,30.6666667 25.3333333,29.4666667 25.3333333,28 L25.3333333,4 C25.3333333,2.53333333 24.1333333,1.34666667 22.6666667,1.34666667 Z M22.6666667,25.3333333 L9.33333333,25.3333333 L9.33333333,6.66666667 L22.6666667,6.66666667 L22.6666667,25.3333333 Z"
          id="Shape"
          fill="#045DE9"
          fillRule="nonzero"
        ></path>
        <path
          d="M11,18.5 L21,18.5 L21,19.5 L11,19.5 L11,18.5 Z M11.575,16.475 L12,15.735 L12.425,16.475 L13.075,16.1 L12.65,15.36 L13.5,15.36 L13.5,14.61 L12.65,14.61 L13.075,13.875 L12.425,13.5 L12,14.235 L11.575,13.5 L10.925,13.875 L11.35,14.61 L10.5,14.61 L10.5,15.36 L11.35,15.36 L10.925,16.1 L11.575,16.475 Z M14.925,16.1 L15.575,16.475 L16,15.735 L16.425,16.475 L17.075,16.1 L16.65,15.36 L17.5,15.36 L17.5,14.61 L16.65,14.61 L17.075,13.875 L16.425,13.5 L16,14.235 L15.575,13.5 L14.925,13.875 L15.35,14.61 L14.5,14.61 L14.5,15.36 L15.35,15.36 L14.925,16.1 Z M21.5,14.61 L20.65,14.61 L21.075,13.875 L20.425,13.5 L20,14.235 L19.575,13.5 L18.925,13.875 L19.35,14.61 L18.5,14.61 L18.5,15.36 L19.35,15.36 L18.925,16.1 L19.575,16.475 L20,15.735 L20.425,16.475 L21.075,16.1 L20.65,15.36 L21.5,15.36 L21.5,14.61 Z"
          id="Shape"
          fill="#045DE9"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

// export function EarthIcon() {
//   return (
//     <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
//       <g id="earth-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <path
//           d="M11.99,2 C6.47,2 2,6.48 2,12 C2,17.52 6.47,22 11.99,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 11.99,2 Z M18.92,8 L15.97,8 C15.65,6.75 15.19,5.55 14.59,4.44 C16.43,5.07 17.96,6.35 18.92,8 Z M12,4.04 C12.83,5.24 13.48,6.57 13.91,8 L10.09,8 C10.52,6.57 11.17,5.24 12,4.04 Z M4.26,14 C4.1,13.36 4,12.69 4,12 C4,11.31 4.1,10.64 4.26,10 L7.64,10 C7.56,10.66 7.5,11.32 7.5,12 C7.5,12.68 7.56,13.34 7.64,14 L4.26,14 Z M5.08,16 L8.03,16 C8.35,17.25 8.81,18.45 9.41,19.56 C7.57,18.93 6.04,17.66 5.08,16 L5.08,16 Z M8.03,8 L5.08,8 C6.04,6.34 7.57,5.07 9.41,4.44 C8.81,5.55 8.35,6.75 8.03,8 L8.03,8 Z M12,19.96 C11.17,18.76 10.52,17.43 10.09,16 L13.91,16 C13.48,17.43 12.83,18.76 12,19.96 Z M14.34,14 L9.66,14 C9.57,13.34 9.5,12.68 9.5,12 C9.5,11.32 9.57,10.65 9.66,10 L14.34,10 C14.43,10.65 14.5,11.32 14.5,12 C14.5,12.68 14.43,13.34 14.34,14 Z M14.59,19.56 C15.19,18.45 15.65,17.25 15.97,16 L18.92,16 C17.96,17.65 16.43,18.93 14.59,19.56 L14.59,19.56 Z M16.36,14 C16.44,13.34 16.5,12.68 16.5,12 C16.5,11.32 16.44,10.66 16.36,10 L19.74,10 C19.9,10.64 20,11.31 20,12 C20,12.69 19.9,13.36 19.74,14 L16.36,14 Z"
//           id="Shape"
//           fill="#045DE9"
//           fillRule="nonzero"
//         ></path>
//       </g>
//     </svg>
//   )
// }

export function LeftArrow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={{ fill: 'currentcolor' }} height="100%" viewBox="0 0 24 24" width="100%">
      <path d="M0 0h24v24H0V0z" fill="none" opacity=".87" />
      <path d="M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z" />
    </svg>
  )
}

export function RightArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ fill: 'currentcolor' }}
      enableBackground="new 0 0 24 24"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
    >
      <g>
        <path d="M0,0h24v24H0V0z" fill="none" />
      </g>
      <g>
        <polygon points="6.23,20.23 8,22 18,12 8,2 6.23,3.77 14.46,12" />
      </g>
    </svg>
  )
}

export function PencilIcon(props) {
  return (
    <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentcolor" {...props}>
      <path
        id="Shape"
        fillRule="evenodd"
        d="m10.8 6.3l0.9 0.9l-8.1 8h-0.8v-0.8zm2.6-5.1l-1.7 1.7l3.4 3.3l1.6-1.6c0.3-0.4 0.3-1 0-1.3l-2.1-2.1q-0.3-0.2-0.6-0.2c-0.2 0-0.5 0.1-0.6 0.2zm-12.5 12.4v3.4h3.4l9.8-9.9l-3.3-3.3z"
      />
    </svg>
  )
}

export function EyeIcon(props) {
  return (
    <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentcolor" {...props}>
      <path
        id="Shape"
        fillRule="evenodd"
        d="m1.4 9.4c1.1-2.9 4-4.8 7.4-4.8c3.4 0 6.3 1.9 7.5 4.8c-1.2 2.8-4.1 4.8-7.5 4.8c-3.4 0-6.3-2-7.4-4.8zm13.4 0c-1.1-2.2-3.4-3.6-6-3.6c-2.6 0-4.8 1.4-6 3.6c1.2 2.1 3.4 3.5 6 3.5c2.6 0 4.9-1.4 6-3.5zm-4.3 0c0-0.9-0.7-1.6-1.7-1.6c-0.9 0-1.7 0.7-1.7 1.6c0 0.8 0.8 1.6 1.7 1.6c1 0 1.7-0.8 1.7-1.6zm-1.7 2.8c-1.7 0-3-1.3-3-2.8c0-1.6 1.3-2.9 3-2.9c1.7 0 3.1 1.3 3.1 2.9c0 1.5-1.4 2.8-3.1 2.8z"
      />
    </svg>
  )
}

// export function InfoIcon(props) {
//   return (
//     <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
//       <g id="info-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <polygon id="Rectangle" fill="#323842" points="10 11 14 11 14 19 10 19"></polygon>
//         <circle id="Oval" fill="#323842" cx="12" cy="7" r="2"></circle>
//       </g>
//     </svg>
//   )
// }
export function HomeIcon(props) {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="home-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon fill="#212121" fillRule="nonzero" points="10 20.5 10 14.5 14 14.5 14 20.5 19 20.5 19 12.5 22 12.5 12 3.5 2 12.5 5 12.5 5 20.5"></polygon>
      </g>
    </svg>
  )
}
export function ScheduleIcon(props) {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="schedule-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.87">
        <path d="M15.727914,16.342 L19.970514,20.5846 L18.556314,21.9988 L14.313714,17.7562 L15.727914,16.342 Z M5.1225,4.32 C5.5125,3.93 6.1425,3.93 6.5325,4.32 L6.5325,4.32 L15.0225,12.81 C15.4125,13.2 15.4125,13.83 15.0225,14.22 L15.0225,14.22 L12.1925,17.05 C11.8025,17.44 11.1725,17.44 10.7825,17.05 L10.7825,17.05 L2.2925,8.56 C1.9025,8.17 1.9025,7.54 2.2925,7.15 L2.2925,7.15 Z M18.4725,2 C20.4054966,2 21.9725,3.56700338 21.9725,5.5 C21.9725,7.43299662 20.4054966,9 18.4725,9 C16.5395034,9 14.9725,7.43299662 14.9725,5.5 C14.9725,3.56700338 16.5395034,2 18.4725,2 Z" id="Combined-Shape" fill="#000000" fillRule="nonzero"></path>
      </g>
    </svg>
  )
}
export function ArrowUpIcon(props) {
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
      <g id="arrow-up" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M27.4137878,15.4634462 C27.0262614,15.8586458 26.5137263,16.0531091 26.0011913,16.0531091 C25.4886563,16.0531091 24.9773713,15.8570775 24.5873447,15.4650144 L18.0006445,8.8579674 L18.0006445,28.0972869 C18.0006445,29.2069822 17.1049582,30.0481928 16.0567616,30.0481928 C15.0085649,30.0481928 14.000371,29.2076095 14.000371,28.0972869 L14.000371,8.8579674 L7.41429587,15.4634462 C6.63299247,16.2475723 5.36728095,16.2475723 4.58597755,15.4634462 C3.80467415,14.67932 3.80467415,13.4090356 4.58597755,12.6249095 L14.5866611,2.58809462 C15.3679645,1.80396846 16.633676,1.80396846 17.4149794,2.58809462 L27.415663,12.6249095 C28.1950912,13.4121721 28.1950912,14.67932 27.4137878,15.4634462 Z" fill="white" fillRule="nonzero"></path>
      </g>
    </svg>
  )
}

export function BallIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_677_851)">
        <path fillRule="evenodd" clipRule="evenodd" d="M19.2281 8.58073C19.3111 8.75379 19.3935 8.92561 19.4902 9.09866C19.8346 10.0508 20 11.0029 20 12.0375C20 16.4533 16.4584 20 12.0483 20C9.62304 20 7.55583 18.9648 6.08084 17.3154C5.99845 17.233 5.90181 17.1436 5.8188 17.0605C7.63822 15.0663 9.71906 13.342 12.0483 11.8651C14.2116 10.4856 16.6374 9.44354 19.2281 8.58073ZM18.3602 7.1938C18.5393 7.37368 18.6223 7.54611 18.7047 7.71855C18.7871 7.80167 18.8837 7.9741 18.9667 8.06342C16.3754 8.92561 13.9501 10.0508 11.7863 11.4371C9.45764 12.8172 7.37618 14.639 5.47437 16.6257C5.39198 16.4533 5.21295 16.2808 5.12994 16.1084C5.04755 16.0185 5.04755 15.9291 4.95091 15.846C6.86635 13.6868 9.01657 11.8651 11.4418 10.3957C13.5227 9.09866 15.8519 7.9741 18.3602 7.1938ZM17.0643 5.81431C17.2439 5.98674 17.4093 6.15918 17.6707 6.33161C17.7538 6.42155 17.9328 6.59399 18.0158 6.76643C15.5075 7.54611 13.2613 8.58073 11.1798 9.96767C8.76816 11.4371 6.59068 13.1689 4.68886 15.3287C4.60647 15.0663 4.52346 14.7215 4.44107 14.4591C4.35868 14.3766 4.35868 14.2041 4.26204 14.1142C6.08084 12.0375 8.16168 10.3125 10.4909 8.92561C12.4894 7.62923 14.722 6.67711 17.0643 5.81431ZM12.0483 4C13.6881 4 15.2455 4.51731 16.5408 5.46943C14.2946 6.24229 12.1307 7.28436 10.1465 8.49141C7.98265 9.87835 5.90181 11.5202 4.17903 13.4245C4.09664 12.9896 4 12.4723 4 12.0375C4 7.62923 7.63822 4 12.0483 4Z" fill="#045DE9" />
      </g>
    </svg>
  )
}

export function BatIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_677_858)">
        <path fillRule="evenodd" clipRule="evenodd" d="M15.806 6.21117L13.4774 10.2012C13.2107 10.6758 12.914 11.1352 12.558 11.6838C12.914 11.4172 13.388 11.1352 13.9374 10.7645L17.956 8.15517L15.806 6.21117ZM15.524 5.6485C15.346 5.6485 15.1534 5.6485 15.0647 5.6485C14.4114 5.6485 13.848 5.92984 13.4774 6.3005L3.70404 16.3412C3.52604 16.4298 3.33337 16.7118 3.33337 17.1718C3.33337 17.4532 3.42204 17.7358 3.61471 18.1058C3.98537 18.6692 4.44537 19.2185 4.83071 19.4998C5.29071 19.9598 6.31404 20.8052 7.24804 20.7158C7.61937 20.7158 7.90071 20.6118 8.07937 20.3305L17.956 10.3938C18.416 9.8305 18.6087 9.0885 18.5054 8.43584L15.524 5.6485ZM21.2934 3.7945C21.2934 3.5125 21.2047 3.2305 20.9227 2.94917C20.7447 2.7705 20.3734 2.6665 20.092 2.6665C19.7214 2.6665 19.4394 2.7705 19.1574 3.0525L16.3694 5.92984L18.1347 7.60517L21.026 4.71317C21.2047 4.4465 21.3974 4.16517 21.2934 3.7945Z" fill="#045DE9" />
      </g>
    </svg>
  )
}

export function AllRounderIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g id="allrounder-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M16.806,7.21133333 L14.4773333,11.2013333 C14.2106667,11.676 13.914,12.1353333 13.558,12.684 C13.914,12.4173333 14.388,12.1353333 14.9373333,11.7646667 L18.956,9.15533333 L16.806,7.21133333 Z M16.524,6.64866667 C16.346,6.64866667 16.1533333,6.64866667 16.0646667,6.64866667 C15.4113333,6.64866667 14.848,6.93 14.4773333,7.30066667 L4.704,17.3413333 C4.526,17.43 4.33333333,17.712 4.33333333,18.172 C4.33333333,18.4533333 4.422,18.736 4.61466667,19.106 C4.98533333,19.6693333 5.44533333,20.2186667 5.83066667,20.5 C6.29066667,20.96 7.314,21.8053333 8.248,21.716 C8.61933333,21.716 8.90066667,21.612 9.07933333,21.3306667 L18.956,11.394 C19.416,10.8306667 19.6086667,10.0886667 19.5053333,9.436 L16.524,6.64866667 Z M22.2933333,4.79466667 C22.2933333,4.51266667 22.2046667,4.23066667 21.9226667,3.94933333 C21.7446667,3.77066667 21.3733333,3.66666667 21.092,3.66666667 C20.7213333,3.66666667 20.4393333,3.77066667 20.1573333,4.05266667 L17.3693333,6.93 L19.1346667,8.60533333 L22.026,5.71333333 C22.2046667,5.44666667 22.3973333,5.16533333 22.2933333,4.79466667 L22.2933333,4.79466667 Z" id="Fill-26" fill="#757A82"></path>
        <path d="M10.6140623,6.29036635 C10.6555676,6.37689475 10.6967632,6.46280287 10.7450829,6.54933127 C10.9172991,7.02539252 11,7.50145377 11,8.01876333 C11,10.2266331 9.22920861,12 7.02415983,12 C5.81152238,12 4.77791544,11.4823803 4.04042125,10.6577244 C3.99922565,10.6164761 3.95090599,10.5718162 3.90940065,10.5302578 C4.81911104,9.53316534 5.85953229,8.67098275 7.02415983,7.93254507 C8.10577668,7.24279899 9.31872387,6.72176778 10.6140623,6.29036635 Z M10.1801146,5.59689862 C10.2696299,5.68683853 10.3111352,5.77305679 10.3523308,5.85927505 C10.3935264,5.90083349 10.4418461,5.98705175 10.4833514,6.03171157 C9.18770327,6.46280287 7.97506582,7.02539252 6.89313923,7.71855011 C5.72882143,8.40860632 4.68809044,9.31948052 3.73718445,10.3128513 C3.69598885,10.2266331 3.60647359,10.1404148 3.56496825,10.0541965 C3.52377265,10.0092266 3.52377265,9.96456678 3.475453,9.92300833 C4.4331733,8.84341927 5.50828558,7.93254507 6.72092303,7.19782904 C7.76134428,6.54933127 8.92597181,5.98705175 10.1801146,5.59689862 Z M9.53213567,4.90715255 C9.62196066,4.99337081 9.70466161,5.07958907 9.83537246,5.16580733 C9.87687781,5.21077728 9.96639306,5.29699554 10.0078984,5.3832138 C8.75375561,5.77305679 7.63063342,6.29036635 6.58990243,6.98383408 C5.38407929,7.71855011 4.29533839,8.58445435 3.3444324,9.66435356 C3.3032368,9.53316534 3.26173145,9.36072882 3.22053585,9.22954061 C3.17934025,9.1882923 3.17934025,9.10207405 3.1310206,9.05710409 C4.04042125,8.01876333 5.0808425,7.1562706 6.24547003,6.46280287 C7.24469568,5.81461524 8.36100356,5.33855398 9.53213567,4.90715255 Z M7.02415983,4 C7.84404522,4 8.62273502,4.25865478 9.27040421,4.73471603 C8.14728202,5.12114751 7.06535543,5.64217872 6.07325383,6.24570653 C4.99132724,6.93917426 3.95090599,7.76010855 3.08951525,8.71223105 C3.04831965,8.49482458 3,8.2361698 3,8.01876333 C3,5.81461524 4.81911104,4 7.02415983,4 L7.02415983,4 Z" id="Fill-60" fill="#757A82"></path>
      </g>
    </svg>
  )
}

export function PollIcon() {
  return (
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 2C8.89543 2 8 2.89543 8 4V16C8 17.1046 8.89543 18 10 18C11.1046 18 12 17.1046 12 16V4C12 2.89543 11.1046 2 10 2Z" style={{ fill: 'currentcolor' }} />
      <path d="M4 10C2.89543 10 2 10.8954 2 12V16C2 17.1046 2.89543 18 4 18C5.10457 18 6 17.1046 6 16V12C6 10.8954 5.10457 10 4 10Z" style={{ fill: 'currentcolor' }} />
      <path d="M16 6C14.8954 6 14 6.89543 14 8V16C14 17.1046 14.8954 18 16 18C17.1046 18 18 17.1046 18 16V8C18 6.89543 17.1046 6 16 6Z" style={{ fill: 'currentcolor' }} />
    </svg>
  )
}

export function HeartIcon() {
  return (
    <svg width="20px" height="20px" viewBox="0 0 20 20">
      <g id="heart-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M10,7.375 C10,4.959 8.041,3 5.625,3 C3.209,3 1.25,4.959 1.25,7.375 C1.25,8.502 1.409,10.159 3,11.75 C4.591,13.341 10,17 10,17 C10,17 15.409,13.341 17,11.75 C18.591,10.159 18.75,8.502 18.75,7.375 C18.75,4.959 16.791,3 14.375,3 C11.959,3 10,4.959 10,7.375" fill="#045DE9" fillRule="nonzero"></path>
      </g>
    </svg>
  )
}

export function QuoteRightIcon() {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M48.1133 42H35.8867L30.3333 30.8933V14H49V32.6667H43.4467L48.1133 42ZM24.78 42H12.5533L7 30.8933V14H25.6667V32.6667H20.1133L24.78 42Z" fill="white" />
    </svg>
  )
}

export const ExclusiveIcon = ExclusiveIconSVG

export const EditorsPickIcon = EditorsPickIconSVG
